OE.addPlugin('Videoposts', (function(){

    var Plugin = {},
        Options = {
            'isPlayingClass' : 'is--playing',
            'querySelector' : '.video-link'
        },
        dataAttributeName = 'data-oe-collapsable',
        vimeo_api = '//player.vimeo.com/api/player.js',
        youtube_api = '//www.youtube.com/iframe_api';

    Plugin.init = function()
    {
        initVideos(); // OE.Utils.loadScript(vimeo_url, initVideos);
    };

    var initVideos = function()
    {
        OE.Utils.delegateEvent(
            CLICK,
            docEventListener,
            Options.querySelector + ':not([data-oe-popup]):not(.popup__overlay):not(.is--login-popup)'
        );

        // stop videos / reset videos within sliders if their corresponding input element is changed
        OE.Utils.delegateEvent(
            'change',
            stop_videos_when_slider_changes,
            '.slider > input'
        );

        var els = document.querySelectorAll(Options.querySelector),
            els_count = els.length;

        // for(var i = 0; i < els_count; i++)
        // {
        //   docEventListener({
        //     target : els[i]
        //   });
        // }
    };

    var docEventListener = function(e)
    {
        try { e.preventDefault(); } catch(ev) {}

        var _this = e.target;

        if(_this.classList.contains('is--vimeo'))
        {
            VimeoVideo.load(_this);
            return false;
        }
        else if(_this.classList.contains('is--youtube'))
        {
            YoutubeVideo.load(_this);
            return false;
        }
    };

    var VimeoVideo = {
        load : function(_this)
        {
            OE.Utils.loadScript(vimeo_api, this.init.bind(this, _this));
        },

        init : function(_this)
        {
            var options = {
                // id : getVimeoIdByUrl(_this.getAttribute('href'))
                url : 'http:' + _this.getAttribute('data-embed'),
                autoplay : true,
                title : false,
                byline : false,
                portrait : false,
                api : true,
                playsinline: false,
                // hide: true,
                muted: _this.hasAttribute('data-mute-video') ? /^(1|true|yes|on)$/i.test(_this.getAttribute('data-mute-video')) : 0
            },
            id = 'vimeo-' + _this.getAttribute('data-provider-id');

            if(typeof _this.player === 'undefined')
            {
                var iframe = getIframe(_this);

                if(iframe)
                {
                    OE.Plugins.Ajax.request('https://vimeo.com/api/oembed.json?url=' + _this.getAttribute('href'), {
                        onSuccess : createPlayer.bind(_this, iframe, options),
                        onError : onError.bind(_this)
                    });
                }
            }
            else
            {
                _this.player.play();
            }
        },

        getVimeoIdByUrl : function(url)
        {
            return url.replace(/(.*)\/(\d+)(\/|$)/,"$2");
        }
    };

    var createPlayer = function(iframe, options)
    {
        var _this = this;
        _this.player = new Vimeo.Player(iframe, options);

        if( options.hide )
        {

        }
        else
        {
          toggleVideo.bind(_this, true)();
        }

        _this.player.on('play', onPlay.bind(_this));
        _this.player.on('pause', onPause.bind(_this));
        _this.player.on('ended', onEnd.bind(_this));
        _this.player.on('error', function (err) {
            if( err && typeof err === 'object' && typeof err.message === 'string' ) {
                if( /^privacyerror$/i.test( err.name ) ) {
                    return false;
                }
            }
            onError.bind(_this)(err);
        });
    };

    var YoutubeVideo = {
        load : function(_this)
        {
            if(typeof _this.player !== 'undefined')
            {
                _this.player.stopVideo(0);
                _this.player.seekTo(0);
                _this.player.playVideo();
            }
            else
            {
                window.onYouTubePlayerAPIReady = this.init.bind(this, _this);
                if(typeof YT === 'undefined')
                {
                    OE.Utils.loadScript(youtube_api);
                }
            }
        },

        init : function(_this)
        {
            var options = {
                enablejsapi : 1,
                modestbranding : 1,
                autoplay : true,
                showinfo : 0
            },
            id = 'youtube-' + _this.getAttribute('data-provider-id');

            if(typeof _this.player === 'undefined')
            {
                var iframe = getIframe(_this);

                if(iframe)
                {
                    _this.player = new YT.Player(iframe, {
                        videoId : _this.getAttribute('data-provider-id'),
                        playerVars : options,
                        events: {
                            'onError' : this.onError.bind(_this),
                            'onReady': this.onPlayerReady.bind(_this),
                            'onStateChange': this.onPlayerStateChange.bind(_this)
                        }
                    });
                }
            }
            else
            {
                _this.player.playVideo();
            }
        },
        onPlayerReady : function(event)
        {
            var _this = this;
            // toggleVideo.bind(_this, true)();
            _this.player.playVideo();

            if( window.innerWidth * (window.pixelDeviceRatio || 1) < 760)
            {
              _this.player.webkitEnterFullScreen ();
            }
        },
        onPlayerStateChange : function( event )
        {
            var _this = this;

            switch(event.data)
            {
                case YT.PlayerState.ENDED :
                    onEnd.bind(_this)();
                    break;
                case YT.PlayerState.PLAYING :
                    onPlay.bind(_this)();
                    break;
                case YT.PlayerState.PAUSED :
                    onPause.bind(_this)();
                    break;
                case YT.PlayerState.BUFFERING :
                    break;
                case YT.PlayerState.CUED :
                    break;
            }
        },
        onError : function()
        {
            var _this = this;
            onError.bind(_this)();
        }
    };


    var stop_videos_when_slider_changes = function(e)
    {
        var playing_divs = document.querySelectorAll('[name="' + this.name + '"].video-input:not(:checked) + label + div.slider-item.is--playing'),
            playing_divs_count = playing_divs.length;

        for(var i = 0; i < playing_divs_count; i++)
        {
            var button = playing_divs[i].querySelector(Options.querySelector);
            if(button)
            {
                toggleVideo.bind(button, false)();
                onEnd.bind(button)();

            }
        }

    };

    var onError = function()
    {

        var iframe = getIframe(this),
            container = getPostContainer(this);

        this.classList.add('has--error');

        if(iframe)
        {
            iframe.classList.add('has--error');
            iframe.parentElement.removeChild(iframe);
        }
        if(container)
        {
            container.classList.add('has--error');
        }

        this.player = false;
    };

    var onLoaded = function()
    {
        toggleVideo.bind(this, true)();
    };

    var getIframe = function(element)
    {
        if(typeof element.playerIframe !== 'undefined')
        {
            return element.playerIframe;
        }

        var insertInto, test_element = element;

        while (test_element && typeof test_element === 'object')
        {
            if(OE.Utils.matches(test_element, '.slider-item, .teaser, .post-header, .video-container'))
            {
                insertInto = test_element.querySelector('.slider-item__image, .teaser-image, .post-thumbnail-wrapper, .video-container-wrapper');
                break;
            }

            test_element = test_element.parentElement;
        }

        if(insertInto)
        {
            element.playerIframe = document.createElement('div');
            element.playerIframe.setAttribute('class', 'post-video');
            insertInto.appendChild(element.playerIframe);

            return element.playerIframe;
        }

        return null;
    };

    var getPostContainer = function(element)
    {
        while (element.parentElement && !OE.Utils.matches(element, '.slider-item, .teaser, .post-header, .video-container'))
        {
            element = element.parentElement;
        }

        return element;
    };


    var onPlay = function()
    {
        stopSiblingVideos(this);
        toggleVideo.bind(this, true)();

        trackVideoEvent(this, 'play');
    };

    var onPause = function()
    {
        if(typeof OE.Plugins.Slider !== 'undefined')
        {
            OE.Plugins.Slider.Play(this);
        }

        trackVideoEvent(this, 'pause');
    };

    var stopSiblingVideos = function(element)
    {
        document.querySelectorAll(Options.querySelector + "." + Options.isPlayingClass).forEach( function( playerLink ) {
            if( playerLink == element) {
                return;
            }
            
            if(typeof playerLink.player !== 'undefined')
            {
                toggleVideo.bind(playerLink)(false);
            }
        });

        return;
    };

    var toggleVideo = function(playing)
    {
        var iframe = getIframe(this),
            container = getPostContainer(this),
            s;

        if(playing)
        {
            this.classList.add('is--playing');

            if(iframe)
            {
                iframe.classList.add('is--playing');
            }

            if(container)
            {
                container.classList.add('is--playing');
            }

            // s = container.parentElement;
            // while(s)
            // {
            //   if(s.classList.contains('slider'))
            //   {
            //     s.classList.add('is--playing');
            //     break;
            //   }
            //   s = s.parentElement;
            // }

            if(typeof OE.Plugins.Slider !== 'undefined')
            {
                OE.Plugins.Slider.updateSliderPlayingState(this);
            }

        }
        else
        {
            if(this.player)
            {
                if(typeof this.player.pause === 'function')
                {
                    this.player.pause();
                }
                else if(typeof this.player.pauseVideo === 'function')
                {
                    this.player.pauseVideo();
                }
            }

            this.classList.remove('is--playing');

            if(iframe)
            {
                iframe.classList.remove('is--playing');
            }
            if(container)
            {
                container.classList.remove('is--playing');
            }

            // s = container.parentElement;
            // while(s)
            // {
            //   if(s.classList.contains('slider'))
            //   {
            //     s.classList.remove('is--playing');
            //     break;
            //   }
            //   s = s.parentElement;
            // }


            if(typeof OE.Plugins.Slider !== 'undefined')
            {
                OE.Plugins.Slider.updateSliderPlayingState(this);
            }
        }
    };

    var playVideo = function(paused)
    {
        if(paused)
        {
            if(typeof this.player.play === 'function')
            {
                this.player.play();
            }
            else if(typeof this.player.playVideo === 'function')
            {
                this.player.playVideo();
            }
        }
    };

    var onEnd = function()
    {
        toggleVideo.bind(this, false)();
        // this.player.setCurrentTime(0);
        // this.player.unload();
        trackVideoEvent(this, 'end');
    };

    /**
     * Tracking provider
     */

    var trackVideoEvent = function(el, type)
    {
        if(typeof OE.Plugins.GA)
        {

            var Tracker = OE.Plugins.GA.getVideoTracker(el);

            if(Tracker)
            {
                if(Tracker[type])
                {
                    Tracker[type]();
                }
            }
        }
    };

    return Plugin;
})());
